const seJSON = {
  'Total gross order value for the selected period window': 'Totala intäkter är alla pengar som kommer in från order, inklusive produkter, moms, frakt och andra avgifter innan returer eller krediter räknas bort.',

'Contribution Margin': 'Täckningsbidrag',
'Total contribution margin for the selected period window': 'Totalt täckningsbidrag för valt tidsintervall',
'Contribution margin is the money gained from the product markup after product cost. It does not include other costs like ads, salaries, rent or tools that can reduce the final profit.': 'Täckningsbidrag är pengarna som tjänas på produktens påslag efter produktkostnad. Det räknar inte med andra kostnader som annonsering, löner, hyra eller verktyg som kan minska den slutliga vinsten.',
'This percentage is the total average markup for the selected period. It compares total contribution margin with the revenue behind those sales.': 'Den här procentsatsen är det totala genomsnittliga påslaget för valt tidsintervall. Den jämför totalt täckningsbidrag med intäkterna bakom försäljningen.',

'Margin Share': 'Täckningsbidrag',
'Online margin': 'Online-marginal',
'Store margin': 'Butiksmarginal',

'Returns are the number of orders customers sent back during this period.': 'Returer är antalet order som kunder har skickat tillbaka under perioden.',
'Return rate and credit rate show how much returns affect orders and revenue.': 'Returandel och kreditandel visar hur mycket returer påverkar order och intäkter.',
'Return rate': 'Returandel',
'Credit rate': 'Kreditandel',
'Return rate is the number of returns as a percentage of the total number of orders.': 'Returandel är antalet returer som procentandel av det totala antalet order.',
'Credit rate is the money paid back through credits and returns compared with total revenue.': 'Kreditandel är pengarna som betalats tillbaka via krediter och returer jämfört med total omsättning.',

  'Help': 'Hjälp',
  'Dashboard': 'Översikt',
  'Charts, stats and KPIs': 'Diagram, statistik och KPI:er',
  'Display Language': 'Visningsspråk',
  'Purchasing (avg/day)': 'Inköp (snitt/dag)',
  'Orders Overview': 'Orderöversikt',
  'KPI Overview': 'KPI-översikt',

  'Sales Channel': 'Försäljningskanal',
  'Store': 'Butik',
  'Online': 'Online',
  'Information': 'Information',
  'Orders (qty)': 'Order (antal)',
  'Orders (value)': 'Order (värde)',
  'Purchases (value)': 'Inköp (värde)',
  'To Ship': 'Att skicka',
  'Shipped': 'Skickade',
  'Returns (qty)': 'Returer (antal)',
  'Credit Notes (qty)': 'Kreditnotor (antal)',
  'Credit Notes (value)': 'Kreditnotor (värde)',
  'Sales Reps': 'Säljare',
  'Period': 'Period',
  'Week': 'Vecka',
  'Month': 'Månad',
  'Year': 'År',

  'Prev {{label}}': 'Föregående {{label}}',
  'Antal': 'Antal',
  'SEK': 'SEK',
  'SEK/day': 'SEK/dag',
  'st': 'st',
  'kr': 'kr',
  'Orders Store ({{total}} st)': 'Order butik ({{total}} st)',
  'Orders Online ({{total}} st)': 'Order online ({{total}} st)',
  'Orders Value Store ({{total}} kr)': 'Ordervärde butik ({{total}} kr)',
  'Orders Value Online ({{total}} kr)': 'Ordervärde online ({{total}} kr)',
  'Purchases Value ({{total}} kr)': 'Inköpsvärde ({{total}} kr)',
  'To Ship ({{total}} st)': 'Att skicka ({{total}} st)',
  'Shipped ({{total}} st)': 'Skickade ({{total}} st)',
  'Returns ({{total}} st)': 'Returer ({{total}} st)',
  'Credit Notes Qty ({{total}} st)': 'Kreditnotor antal ({{total}} st)',
  'Credit Notes Value ({{total}} kr)': 'Kreditnotor värde ({{total}} kr)',
  '{{repName}} ({{total}} st)': '{{repName}} ({{total}} st)',

  'Jan': 'Jan',
  'Feb': 'Feb',
  'Mar': 'Mar',
  'Apr': 'Apr',
  'May': 'Maj',
  'Jun': 'Jun',
  'Jul': 'Jul',
  'Aug': 'Aug',
  'Sept': 'Sep',
  'Oct': 'Okt',
  'Nov': 'Nov',
  'Dec': 'Dec',
  'Sun': 'Sön',
  'Mon': 'Mån',
  'Tue': 'Tis',
  'Wed': 'Ons',
  'Thu': 'Tor',
  'Fri': 'Fre',
  'Sat': 'Lör',
  'Last 7 Days': 'Senaste 7 dagarna',
  'Last 4 Weeks': 'Senaste 4 veckorna',
  'Last 30 Days': 'Senaste 30 dagarna',
  'Last 12 Months': 'Senaste 12 månaderna',
  'Today': 'Idag',
  'This week': 'Den här veckan',
  'This month': 'Den här månaden',
  'Avg/day': 'Snitt/dag',
  'Performance ({{windowHeader}})': 'Prestanda ({{windowHeader}})',
  'Total Revenue': 'Total omsättning',
  'Total Orders': 'Totalt antal order',
  'Total number of orders for the selected period window': 'Totalt antal order för valt tidsintervall',
  'Returns': 'Returer',
  'Total quantity returned for the selected period window': 'Totalt returnerat antal för valt tidsintervall',
  'Channel Breakdown ({{windowHeader}})': 'Kanalfördelning ({{windowHeader}})',
  'In-Store': 'I butik',
  'Revenue Share': 'Omsättning',
  'Orders Share (Qty)': 'Order (antal)',
  'Operations Overview': 'Operativ översikt',
  'Operations Overview ({{windowHeader}})': 'Operativ översikt ({{windowHeader}})',
  'Number of open orders currently waiting to be shipped': 'Antal öppna order som väntar på att skickas',
  'Orders waiting to be shipped during the selected dashboard period': 'Order som väntar på att skickas under valt dashboardintervall',
  'TO SHIP (OPEN)': 'ATT SKICKA (ÖPPNA)',
  'TO SHIP': 'ATT SKICKA',
  'Total orders shipped so far this current calendar month': 'Totalt antal order skickade hittills denna kalendermånad',
  'Orders shipped during the selected dashboard period': 'Order skickade under valt dashboardintervall',
  'SHIPPED (MO)': 'SKICKADE (MÅN)',
  'SHIPPED': 'SKICKADE',
  'Total value of purchase orders over the last 3 months': 'Totalt värde av inköpsorder under de senaste 3 månaderna',
  'Total purchasing value during the selected dashboard period': 'Totalt inköpsvärde under valt dashboardintervall',
  'PURCHASING (3 MO)': 'INKÖP (3 MÅN)',
  'PURCHASING': 'INKÖP',
  'Credit note count during the selected dashboard period': 'Antal kreditnotor under valt dashboardintervall',
  'CREDIT NOTES': 'KREDITNOTOR',
  'CREDITS': 'KREDITER',
  'Total credit note net value during the selected dashboard period': 'Totalt kreditnotvärde netto under valt dashboardintervall',
  'CREDIT NOTE VALUE': 'KREDITNOTVÄRDE',
  'CREDITS VALUE': 'KREDITVÄRDE',
  'Historical Overview ({{period}})': 'Historisk översikt ({{period}})',

  'Purchases Value Store ({{total}} kr)': 'Inköpsvärde butik ({{total}} kr)',
  'Purchases Value Online ({{total}} kr)': 'Inköpsvärde online ({{total}} kr)',
  'To Ship Store': 'Att skicka butik',
  'To Ship Online': 'Att skicka online',
  'Shipped Store': 'Skickade butik',
  'Shipped Online': 'Skickade online',
  'Returns Store': 'Returer butik',
  'Returns Online': 'Returer online',
  'Total Daily Orders': 'Totalt antal order per dag',
  'Avg/Day': 'Snitt/dag',
  'Order Value Avg': 'Snittordervärde',
  'Kr/Order': 'Kr/order',
  'Returns (weekly)': 'Returer (vecka)',
  'Qty/Week': 'Antal/vecka',
  'No enabled KPIs.': 'Inga KPI:er är aktiverade.',
  'Set and Enable in settings': 'Ställ in och aktivera i inställningarna',
  Blueprints: 'Plans',
  'Extended Sidebar': 'Barre latérale étendue',
  'Accent Sidebar': "Barre latérale d'accentuation",
  'Accent Header': 'En-tête accentué',
  'Boxed Sidebar': 'Barre latérale en boîte',
  'Collapsed Sidebar': 'Barre latérale réduite',
  'Bottom Navigation': 'Navigation du bas',
  'Top Navigation': 'Navigation supérieure',
  'Lead Developer': 'Développeur principal',
  'Mega menu': 'Méga menu',
  Doctors: 'Läkare',
  Reports: 'Rapporter',
  'Custom dashboard built using the included components':
    "Tableau de bord personnalisé construit à l'aide des composants inclus",
  Hospital: 'Sjukhus',
  Export: 'Export',
  'Last year': "L'année dernière",
  Expenses: 'Kostnader',

  Statistics: 'Statistik',
  General: 'Allmän',
  Automation: 'Automatiserad',
  'Data Display': 'Datavisning',
  Calendar: 'Kalender',
  Mailbox: 'Inkorg',
  Dashboards: 'Dashboard',
  Analytics: 'Analys',
  Banking: 'Bancaire',
  Commerce: 'Handel',
  Crypto: 'Crypto',
  Finance: 'Finanser',
  Fitness: 'Hälsa',
  Healthcare: 'Soins de santé',
  'Doctors Page': 'Page des médecins',
  'Hospital Overview': "Aperçu de l'hôpital",
  Helpdesk: "Information",
  Learning: 'Lärande',
  Monitoring: 'Undersökning',
  Tasks: 'Uppgifter',
  Applications: 'Applikationer',
  'File Manager': 'Filhanterare',
  'Jobs Platform': "Arbetsplatform",
  Messenger: 'Medellanden',
  'Projects Board': 'Whiteboard',
  Management: 'La gestion',
  Users: 'Användare',
  'List All': 'Visa alla',
  'User Profile': "Användar profil",
  Projects: 'Projekt',
  Shop: 'Shop',
  'Products List': 'Produkter',
  'View Product': 'Visa product',
  'Create Product': 'Skapa product',
  Invoices: 'Fakturor',
  'View Single': 'visa faktura',
  'Auth Pages': "Pages d'authentification",
  Login: 'Logga in',
  Basic: 'Basic',
  Cover: 'Couvrir',
  Register: "Regristrera",
  Wizard: 'Wizard',
  'Recover Password': 'Glömt lösenord',
  Status: 'Status',
  Foundation: 'Fondation',
  'Extra Pages': 'Pages supplémentaires',
  'Error 404': 'Error 404',
  'Error 500': 'Error 500',
  'Coming Soon': 'Kommer snart',
  Maintenance: 'Underhåll',
  Overview: 'Översikt',
  'Layout Starters': 'Démarreurs de mise en page',
  'Starter Kit 1': 'Kit de démarrage 1',
  'Starter Kit 2': 'Kit de démarrage 2',
  Documentation: 'Dokumentation',
  Welcome: 'Välkommen',
  'Features tour': 'Visite des fonctionnalités',
  'Getting started guide': 'Guide de Démarrage',
  'Contact support': 'Kontakta oss',
  Version: 'Version',
  Search: 'Sök',
  Notifications: 'Notiser',
  Settings: 'Inställningar',
  'Language Switcher': 'Välj Språk',
  'Sign out': 'Logga ut',
  'Change Theme': 'Ändra tema',
  'View all notifications': 'Visa alla notiser',
  'Tokyo NextJS Typescript Admin Dashboard':
    "Tableau de bord d'administration de Tokyo React",
  'High performance React template built with lots of powerful Material-UI components across multiple product niches for fast & perfect apps development processes':
    "Modèle React haute performance construit avec de nombreux composants Material-UI puissants dans plusieurs niches de produits pour des processus de développement d'applications rapides et parfaits",
  'Browse Live Preview': "Parcourir l'aperçu en direct",
  'Live Preview': 'Aperçu en direct',
  'Key Features': 'Principales caractéristiques',
  dashboards: 'dashboard',
  applications: 'applikationer',
  'management sections': 'sections de gestion',
  'dark/light themes': 'thèmes sombres / clairs',
  components: 'komponenter',
  'Some of the features that make Tokyo one of the best admin templates available today':
    "Certaines des fonctionnalités qui font de Tokyo l'un des meilleurs modèles d'administration disponibles aujourd'hui",
  'Design Source Files': 'Fichiers source de conception',
  'Start working on your project directly from one of the included starter kits or use the Figma/Sketch files to create a prototype first':
    "Commencez à travailler sur votre projet directement à partir de l'un des kits de démarrage inclus ou utilisez les fichiers Figma / Sketch pour créer d'abord un prototype",
  'We only translated a small part of the template, for demonstration purposes':
    "Nous n'avons traduit qu'une petite partie du modèle, à des fins de démonstration",
  "Charts, Stats and KPI's from both web and in-store purchases in one convenient location": "Grafer och statistik från både web och butik på en och samma plats",
  "Cancel": "Avbryt",
  "Orders": "Ordrar",
  "Refunds": "Återbetalningar",
  "days": "dag",
  Products: 'Produkter',
  "Search...": "Sök...",
  "...": "...",
  "Rows per page:": "Visas",
  "Products are not sold directly to customer. That is a Sales Item. Some products have a matching Sales Item while others are only sold togheter with other products in a Sales Item.":
    "Produkter säljs inte direkt till en kund. Det gör Sales Item. Vissa produkter har ett eget Sales Item medans andra är sålda i kombination med andra produkter.",
  // "Product type":"Produkttyp",
  "Product Types": "Produkttyper",
  "View and edit of Product Types": "Visa och ändra produkttyper.",
  "Product types": "Produkttyper",
  "Collapse All": "Dölj alla",
  "Expand All": "Visa alla",
  "Select all": "Välj alla",
  "We couldn't find anything matching your search criteria": "Inga produkter matchade din sökning",
  "Sales Items": "Varor",
  "Sales Items are sold, can contain several products": "Sales Items säljs till kunder och kan innehålla flera olika produkter.",
  "New Sales Item": "Skapa Sales Item",
  "Edit": "Ändra",
  "Columns": "Kolumner",
  "Supplier Products": "Leverantörsprodukter",
  "View and edit of Supplier Products": "Visa och ändra Supplier Products",
  "Manufacturers": "Tillverkare",
  "View and edit of Manufacturers": "Visa och ändra tillverkare",
  'Development': 'Utveckling',
  'Testing': 'Testning',
  'Test Overview': 'Testöversikt',
  'Status Page': 'Statussida',
  'Api Test': 'API-test',
  'Olles Testsida': 'Olles testsida',
  'Kalles Testsida': 'Kalles testsida',
  'Kalles Testsida 2': 'Kalles testsida 2',
  'Kalles Testsida 3': 'Kalles testsida 3',
  'Eriks Testsida': 'Eriks testsida',
  'Hannes Testsida': 'Hannes testsida',
  'Templates': 'Mallar',
  'Content Cards': 'Innehållskort',
  'Mui Data Grid(Table pages)': 'MUI Data Grid (tabellsidor)',
  'Formik (Edit pages)': 'Formik (redigeringssidor)',

  'Categories': 'Kategorier',
  'Suppliers': 'Leverantörer',
  'Product Lines': 'Produktlinjer',
  'Customers': 'Kunder',
  'Campaigns': 'Kampanjer',
  'Payments': 'Betalningar',
  'Credit Notes': 'Kreditnotor',
  'Billable Orders': 'Debiterbara ordrar',
  'Purchase Order': 'Inköpsorder',
  'Purchase Order Draft': 'Utkast till inköpsorder',
  'Backorders': 'Restorder',
  'Low Order Points': 'Beställningspunkter',
  'Warehouse': 'Lager',
  'Warehouses': 'Lager',
  'Transfers': 'Förflyttningar',
  'Fullfillment Orders': 'Uppfyllelseorder',
  'Admin': 'Admin',
  'Account': 'Konto',
  'Currencies': 'Valutor',
  'Order Origins': 'Orderursprung',
  'Tax Rates': 'Momssatser',
  'Shipping Settings': 'Fraktinställningar',
  'Sales Shipping Methods': 'Fraktmetoder för försäljning',
  'Warehouse Shipping Methods': 'Fraktmetoder för lager',
  'Purchasing Shipping Methods': 'Fraktmetoder för inköp',
  'Purchasing Shipping Terms': 'Leveransvillkor för inköp',
  'Logout': 'Logga ut',
  "Purchasing": "Inköp",
  "Quick Links": "Snabblänkar",
  "English": "Engelska",
  "Swedish": "Svenska",
  "Return rate and credit rate in relation to sales": "Returer och krediter i förhållande till ordrar och försäljning",



};

export default seJSON;
